import { ChangeEvent, FC } from 'react';
import { FormProps } from '../';
import FormControl from '../form-control';
import { Box, Stack } from '@mui/material';
import BaseSwitch from '../base-switch';

interface Props extends FormProps {
  checked: boolean;
  onChange: (checked: boolean, event: ChangeEvent<HTMLInputElement>) => void;
}

const Switch: FC<Props> = ({
  label,
  checked,
  onChange,
  error,
  name,
  fullWidth,
  disabled,
  readonly,
  size = 'medium',
}) => {
  const handleChange = (event: ChangeEvent<HTMLInputElement>) =>
    onChange(event.target.checked, event);

  const hasLabel = !!label;

  return (
    <FormControl label="" error={error} name={name} fullWidth={fullWidth}>
      <Stack direction="row" gap={2} alignItems="center">
        {hasLabel && <Box>{label}</Box>}
        <BaseSwitch
          checked={checked}
          onChange={handleChange}
          disabled={disabled}
          readonly={readonly}
          size={size}
        />
      </Stack>
    </FormControl>
  );
};

export default Switch;
